const PIXEL_ID = '2243850073137099'
const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

type FbqFunction = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

type PixelWindow = Window & {
  fbq?: FbqFunction
  _fbq?: FbqFunction
}

export type AddToCartPayload = {
  content_name: string
  content_ids: string[]
  content_type: string
  value: number
  currency: string
}

let initialized = false

function getPixelWindow(): PixelWindow | null {
  if (typeof window === 'undefined') return null
  return window as PixelWindow
}

/** Loads the Meta Pixel and fires a single PageView for this session. */
export function initMetaPixel(): void {
  const win = getPixelWindow()
  if (!win || initialized) return
  initialized = true

  if (!win.fbq) {
    const fbq: FbqFunction = function queued(...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
        return
      }
      fbq.queue?.push(args)
    }
    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq
    win.fbq = fbq
    win._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = FBEVENTS_SRC
    document.head.appendChild(script)
  }

  win.fbq('init', PIXEL_ID)
  win.fbq('track', 'PageView')
}

/**
 * Fires AddToCart. Only called when the shopper is actually being sent to the
 * Shopify cart, so the event always pairs with a real checkout arrival.
 */
export function trackAddToCart(payload: AddToCartPayload): void {
  const win = getPixelWindow()
  win?.fbq?.('track', 'AddToCart', payload)
}
